import { Eject } from "@mui/icons-material";
import Excel from "exceljs";

export default function extractStock(e, id) {
  return new Promise((resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    const tempRow = [];

    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then((workBook) => {
        workBook.eachSheet((sheet) => {
          sheet.eachRow((row, rowIndex) => {
            if (rowIndex > 1) {
              const tempCell = [];
              const stockBatch = [];
              row.eachCell((cell, cellIndex) => {
                if (cellIndex === 1) {
                  if (cell.value !== id) {
                    reject("discount_not_match");
                  }
                }
                if (cellIndex === 4) tempCell[1] = cell.value;
                if (cellIndex > 7) stockBatch.push(cell.value);
              });
              tempCell[0] = id;
              tempCell[2] = stockBatch;
              tempRow.push(tempCell);
            }
          });
        });
        if (tempRow.length > 0) resolve(tempRow);
      });
    };
  });
}
